import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const _LogoutIconAccountMenu: FunctionComponent<{ className?: string }> = ({ className }) => (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 21' fill='none' className={className}>
        <path
            d='M3.75 3.4231V18.4231H16.25V12.7981H15V17.1731H5V4.6731H15V9.0481H16.25V3.4231H3.75ZM10.9375 7.7981L8.24219 10.4739L7.8125 10.9231L8.24219 11.3723L10.9375 14.0481L11.8164 13.1692L10.1953 11.5481H17.5V10.2981H10.1953L11.8164 8.677L10.9375 7.7981Z'
            fill='#9F1B1F'
        />
    </svg>
);

const LogoutIconAccountMenu = styled(_LogoutIconAccountMenu)``;

export default LogoutIconAccountMenu;
